<template lang="pug">
    div
      el-row
        el-col
          h3.title
            | Transferencias Pendientes Global - {{ selectedCountryName }}
      el-row
        el-col
          el-form(:inline="true" label-position="top" size="mini")
            el-form-item(label="País:")
              select-input(:options="countries" :attribute="search" modelKey="country")
            el-form-item(label="Operadores:")
              select-input(
                :options="filteredConciliables"
                :attribute="search"
                modelKey="operators"
                :multiple="true"
              )
            el-form-item(label="Por Día de transferencia:")
              date-input(:inputModel="search")
            el-form-item(label="Banco" v-if="search.country === 'MX'")
              select-input(
                :options="mxBanks"
                :attribute="search"
                modelKey="bank"
              )
            el-form-item.filters__buttons-wrapper
              el-button(
                type="primary"
                icon="el-icon-search"
                @click.prevent="fetchPendingTransfers()"
              ) FILTRAR
            el-form-item(v-if="canSeeButton() && search.country === 'MX'").filters__buttons-wrapper
              el-dropdown(trigger="click")
                el-button(type="success")
                  | EXPORTAR NÓMINA
                  i.el-icon-download.el-icon--right
                el-dropdown-menu(slot="dropdown")
                  el-dropdown-item(@click.native.prevent="handleExportPayroll('banorte')") Banorte
                  el-dropdown-item(
                    @click.native.prevent="handleExportPayroll('other_banks')"
                  ) Otros Bancos
            el-form-item(v-if="canSeeButton() && search.country === 'MX'").filters__buttons-wrapper
              el-button(
                type="warning"
                icon="el-icon-upload2"
                @click.prevent="handleImportPayroll"
                :disabled="canImportPayroll()"
              ) IMPORTAR
      el-row
        el-col
          data-table(
            :headers="headers"
            :items="items"
            :summaries="summaries"
            :height="500"
            :shownSummary="true"
            :loading="loading"
            :shownEdit="false"
            @cellClickEvent="handleCellClick"
            refTable="pendingTransfersTable"
            :stripe="false"
            :shownActions="showActions"
            :shownSelection="true"
            @select="handleSelectionChange"
          )
            template(slot="additionalActions" slot-scope="scope")
              template(v-if="shownDiscountActions(scope.row)")
                a.el-button.el-button--primary.el-button--mini(
                  :href="mailerDiscountPreview(scope.row)"
                  @click.stop="showMailerDiscountPreview(scope.row)"
                  target="_blank"
                )
                  i(class="el-icon-view")
                el-button(
                  type="info"
                  icon="el-icon-message"
                  size="mini"
                  @click="sendMailerDiscount(scope.row)"
                  :disabled="scope.row.disabled || scope.row.can_be_sent"
                )
      el-dialog(
        title="Subir archivo PDF de Banorte"
        :visible.sync="uploadDialog.visible"
        :close-on-click-modal="false"
        :show-close="false"
      )
        el-form(:inline="true" :model="uploadDialog" :rules="uploadFormRules" ref="form")
          el-row
            el-col
              el-form-item(label="Selecciona un archivo PDF:" prop="files")
                el-upload(
                  v-model="uploadDialog.files"
                  action=""
                  accept=".pdf"
                  :file-list="uploadDialog.files"
                  :auto-upload="false"
                  :on-change="handleChangeFile"
                )
                  el-button(slot="trigger" size="small" type="primary") Buscar
          el-row.inline-form__actions
            el-button(@click="closeUploadDialog()") Cancelar
            el-button(
              type="warning"
              icon="el-icon-upload2"
              @click.prevent="uploadPayrollFile()"
              :loading="submitLoading"
            ) Subir
  </template>

<script>
import SelectInput from '@/components/forms/inputs/SelectInput.vue';
import DataTable from '@/components/tables/DataTable.vue';
import DateInput from '@/components/forms/inputs/DateInput.vue';

// eslint-disable-next-line import/no-cycle
import FinanceApi from '@/services/apiService';
import DataService from '@/services/dataService';
import DateService from '@/services/dateService';
import store from '@/store';
import permissions from '@/constants/permissions';

// eslint-disable-next-line import/no-cycle
import conciliables from '@/mixins/conciliables';
import pendingTransfers from '@/mixins/pendingTransfers';

export default {
  name: 'PendingTransfersGlobal',
  components: {
    SelectInput, DataTable, DateInput,
  },
  mixins: [
    conciliables, pendingTransfers,
  ],
  data() {
    return {
      items: [],
      summaries: [],
      search: {
        country: 'MX',
        operators: [],
        date: DateService.getDate(),
        bank: 'all',
      },
      operators: [],
      selectedRows: [],
      batchTransference: null,
      batchTransferences: [],
      selectedCountry: null,
      loading: false,
      uploadDialog: {
        visible: false,
        confirmDate: false,
        confirmFilename: false,
        files: [],
      },
      submitLoading: false,
      channelMessage: '',
    };
  },
  beforeMount() {
    this.fetchPendingTransfers();
  },
  methods: {
    fetchPendingTransfers() {
      this.searchBanorte = false;
      this.searchOthersBanks = false;
      this.loading = true;
      FinanceApi.get_pending_transfers(this.search).then((data) => {
        this.items = data.body.pending_transfers.map((pendingTransfer) => ({
          ...pendingTransfer,
          disabled: true,
        }));
        this.batchTransference = data.body.batch_transference;
        this.batchTransferences = data.body.batch_transferences;
        if (data.body.pending_transfers.filter((transfer) => transfer.bank_name === 'Banorte').length > 0) { this.searchBanorte = true; }
        if (data.body.pending_transfers.filter((transfer) => transfer.bank_name !== 'Banorte').length > 0) { this.searchOthersBanks = true; }
        this.loading = false;
        this.summaries = data.body.summary;
      }).catch((exception) => {
        this.$notify.error({ title: 'Error', message: exception.body.message });
        this.loading = false;
      });
      this.selectedCountry = this.search.country;
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleExportPayroll(type) {
      if (this.validateRecords(type)) {
        this.validateExport(type);
        const operators = this.selectedRows.map((row) => row.operator) || [];
        if (this.batchTransferenceStatus === 'text_downloaded') { return this.textDownloadedMessage(type); }
        this.exportPayroll(type, operators);
      } else {
        this.$notify.error({ title: 'Error', message: 'No hay transferencias pendientes para exportar' });
      }
      return false;
    },

    validateRecords(type) {
      let anyRecords = false;
      if (type === 'banorte') {
        if (this.searchBanorte) {
          anyRecords = true;
        }
      } else if (type === 'other_banks') {
        if (this.searchOthersBanks) {
          anyRecords = true;
        }
      }
      return anyRecords;
    },

    textDownloadedMessage(type) {
      const message = `Ya fue exportado por ${this.batchTransference.user.name} a las
          ${this.batchTransference.updated_time}. ¿Estás seguro que quieres exportar de nuevo?`;
      this.$confirm(message, '¡Cuidado!', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        this.exportPayroll(type);
      }).catch(() => {});
    },
    async exportPayroll(type, operators) {
      await FinanceApi.export_mx_payroll(this.search, type, operators).then(() => {
        this.channelMessage = this.$message({
          type: 'success',
          message: 'Se está generando el archivo de texto, esto puede tardar unos minutos. Al cerrar el navegador o pestaña se perderá la descarga',
          duration: 0,
          showClose: true,
        });
      });
    },
    mailerDiscountPreview(row) {
      return FinanceApi.url_mailer_discount_preview(row.operator, this.search.date);
    },
    showMailerDiscountPreview(row) {
      // eslint-disable-next-line no-param-reassign
      row.disabled = false;
      this.$notify({
        title: 'Correo previsualizado',
        message: 'Correo previsualizado exitosamente, listo para ser enviado',
        type: 'success',
      });
    },
    sendMailerDiscount(row) {
      FinanceApi.send_mailer_discount(row.operator, this.search.date).then(() => {
        this.fetchPendingTransfers();
        this.$notify({
          title: 'Mail Enviado',
          message: 'Mail enviado exitosamente',
          type: 'success',
        });
      });
    },
    shownDiscountActions(row) {
      return row.discounts !== 0;
    },
    handleImportPayroll() {
      const validState = this.batchTransferenceStatus === 'pdf_processed' || this.batchTransferenceStatus === 'pdf_uploaded';
      if (validState && !this.uploadDialog.confirmDate) {
        this.uploadDialog.visible = false;
        this.confirmDateMessage();
        this.stopSubmitLoading();
        return;
      }

      if (this.batchTransferenceCompleted()) {
        this.pdfCompletedMessage();
      } else if (!this.batchTransference) {
        this.$alert('No has descargado el txt para el día seleccionado', 'Cuidado', {
          showConfirmButton: false,
        });
      } else {
        this.uploadDialog.visible = true;
      }
    },
    confirmDateMessage() {
      const message = `Hoy ya fue importado por ${this.batchTransference.user.name} a las
          ${this.batchTransference.updated_time}. ¿Estás seguro que quieres importar de nuevo?`;
      this.$confirm(message, '¡Cuidado!', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        this.uploadDialog.confirmDate = true;
        this.uploadDialog.visible = true;
      }).catch(() => {
        this.uploadDialog.files = [];
      });
    },
    pdfCompletedMessage() {
      this.$alert('La carga de la nómina está completa para el día seleccionado', 'No existen transferencias pendientes', {
        showConfirmButton: false,
      });
    },
    canImportPayroll() {
      if (!this._.get(this.batchTransference, 'status')) { return true; }

      if (this.batchTransference && this.batchTransferenceCompleted()) { return true; }

      return false;
    },
    batchTransferenceCompleted() {
      return this.batchTransferenceStatus === 'pdf_processed' && this.batchTransference.failed_count === 0;
    },
    closeUploadDialog() {
      this.uploadDialog.visible = false;
      this.uploadDialog.confirmDate = false;
      this.uploadDialog.confirmFilename = false;
      this.uploadDialog.files = [];
    },
    handleChangeFile(file) {
      // eslint-disable-next-line prefer-destructuring
      this.uploadDialog.files = [file.raw];
    },
    uploadPayrollFile() {
      this.startSubmitLoading();
      const { form } = this.$refs;

      form.validate((valid) => {
        if (valid) {
          const params = { filename: this.uploadDialog.files[0].name };

          FinanceApi.historic_filename_import(params).then((data) => {
            if (!this.uploadDialog.confirmFilename && data.body > 0) {
              this.uploadDialog.visible = false;
              this.confirmFilenameMessage();
              this.stopSubmitLoading();
            } else {
              const formData = new FormData();
              formData.append('id', this.batchTransference.id);
              formData.append('file', this.uploadDialog.files[0]);

              FinanceApi.import_mx_payroll(formData).then(() => {
                this.closeUploadDialog();
                this.$notify({
                  title: 'Carga exitosa.',
                  message: 'El archivo se ha subido con éxito.',
                  type: 'success',
                });
                this.fetchPendingTransfers();
                this.stopSubmitLoading();
              }).catch((exception) => {
                this.$notify.error({ title: 'Archivo inválido.', message: exception.body.message });
                this.stopSubmitLoading();
              });
            }
          }).catch((exception) => {
            this.$notify.error({ title: 'Error al validar nombre de archivo.', message: exception.body.message });
            this.stopSubmitLoading();
          });
        } else {
          this.stopSubmitLoading();
        }
      });
    },
    confirmFilenameMessage() {
      const message = `El archivo ${this.uploadDialog.files[0].name} ya fue importado por
        ${this.batchTransference.user.name} el dia ${this.batchTransference.updated_date}.
        ¿Estás seguro que quieres importar de nuevo?`;
      this.$confirm(message, '¡Cuidado!', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        this.uploadDialog.confirmFilename = true;
        this.uploadDialog.visible = true;
      }).catch(() => {
        this.uploadDialog.files = [];
        this.uploadDialog.visible = true;
      });
    },
    startSubmitLoading() {
      this.submitLoading = true;
    },
    stopSubmitLoading() {
      this.submitLoading = false;
    },
    validateExport(type) {
      if (this.batchTransferences.length > 0) {
        const batchTransference = this.batchTransferences.find((element) => (
          element.bank === type
        ));
        if (batchTransference) {
          this.batchTransference = batchTransference;
        } else { this.batchTransference = {}; }
      }
    },
    canSeeButton() {
      const role = store.state.user.role || '';
      return permissions.FinanceGroup.includes(role);
    },
  },
  computed: {
    headers() {
      const headersArray = [
        { key: 'operator', label: 'Operador' },
        { key: 'national_id', label: this.selectedCountry === 'MX' ? 'RFC' : 'Rut' },
        { key: 'holder', label: 'Titular de la cuenta' },
        { key: 'bank_name', label: 'Banco' },
        { key: 'number', label: 'Numero de Cuenta' },
        { key: 'dates_to_transfer', label: 'Fechas a transferir' },
        {
          key: 'to_transfer', label: 'A Transferir', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'pendings', label: 'Pendientes', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'discounts', label: 'Descuentos', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'calculated_to_transfer', label: 'A Transferir con descuentos y pendientes', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'transfer_amount', label: 'Transferido', type: 'currency', country: this.selectedCountry,
        },
      ];
      if (this.selectedCountry === 'MX') {
        headersArray.splice(1, 0, { key: 'banorte_id', label: 'ID Tercero' });
      }
      return headersArray;
    },
    countries() {
      return DataService.get_countries().filter((country) => country.key !== 'CL');
    },
    selectedCountryName() {
      return this.countries.find((country) => country.key === this.selectedCountry).value;
    },
    showActions() {
      return this.items.some((item) => item.discounts !== 0);
    },
    uploadFormRules() {
      return {
        files: [{ required: true, message: 'Es requerido', trigger: 'blur' }],
      };
    },
    mxBanks() {
      return [
        { key: 'all', value: 'Todos' },
        { key: 'banorte', value: 'Banorte' },
        { key: 'other_banks', value: 'Otros Bancos' }];
    },
    batchTransferenceStatus() {
      return this._.get(this.batchTransference, 'status');
    },
  },
  channels: {
    PrivateChannel: {
      received(data) {
        if (data.status === 'error') {
          setTimeout(() => {
            this.channelMessage.close();

            this.$message({
              type: 'error',
              message: 'Falló la descarga',
              duration: 7000,
              showClose: true,
            });
          }, 3000);
        } else {
          this.fetchPendingTransfers();
          setTimeout(() => {
            this.channelMessage.close();
          }, 3000);
        }
      },
    },
  },
};
</script>
